import fetch from "cross-fetch";
import { IAM_API_URL } from "../../config";
import { shouldFetchUser } from "./selectors.js";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import { navigate } from "../navigation/operations";
import fetchRetry from "../fetch_retry";

export function fetchUser(id) {
  return function (dispatch, getState) {
    if (!id) {
      return;
    }
    if (!shouldFetchUser(getState(), id)) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingUser(id));
    let url = `${IAM_API_URL}/user/${id}`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(url, request_options)
    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingUser(error));
        }
      )
      .then((response) => {
        if ("message" in response && response.message === "Internal Server Error") {
          dispatch(pushNotification("errors.users.fetch", "error"));
          dispatch(ActionCreators.errorFetchingUser(response.message));
        } else {
          dispatch(ActionCreators.fetchedUser(response));
        }
      });
  };
}

export function updateUser(id, payload) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.updatingUser());
    let url = `${IAM_API_URL}/user/${id}`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "PATCH",
      body: JSON.stringify(payload),
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(url, request_options)
    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorUpdatingUser(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(pushNotification("errors.users.update", "error"));
          dispatch(ActionCreators.errorUpdatingUser(response.message));
        } else {
          dispatch(ActionCreators.updatedUser(response));
          dispatch(pushNotification("success.update_user_details.successfully_saved", "success"));
        }
      });
  };
}

export function resetPassword(payload, redirectTo) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.updatingUser());
    let url = `${IAM_API_URL}/user/reset-password`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "PATCH",
      body: JSON.stringify(payload),
    };

    return fetch(url, request_options)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorUpdatingUser(error));
        }
      )
      .then((response) => {
        dispatch(ActionCreators.stopLoader());
        if ("message" in response && response.message === "Item not found") {
          dispatch(pushNotification("errors.users.error_on_reset_password", "error"));
          dispatch(ActionCreators.errorResetUserPassword(response.message));
        } else {
          // dispatch(receivedAuth(response.access_token, response.refresh_token));
          // window.location.href = THANK_YOU_PAGE
          dispatch(pushNotification("success.update_user_details.successfully_changed_password", "success"));
          if (redirectTo) {
            dispatch(navigate(redirectTo));
          }
        }
      });
  };
}

export function recoverPassword(u_name, redirectTo) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.updatingUser());
    let url = `${IAM_API_URL}/user/reset-password`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ u_name }),
    };

    return fetch(url, request_options)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorUpdatingUser(error));
          dispatch(pushNotification("errors.users.error_on_reset_password", "error"));
        }
      )
      .then((response) => {
        if ("reset_request_sent" in response && response.reset_request_sent === true) {
          dispatch(pushNotification("success.update_user_details.recover_email_send", "success"));
          dispatch(ActionCreators.stopLoader());
          if (redirectTo) {
            dispatch(navigate(redirectTo));
          }
        } else {
          dispatch(pushNotification("errors.users.error_on_reset_password", "error"));
          dispatch(ActionCreators.errorResetUserPassword(response.message));
        }
      });
  };
}

export function activateAccount(token, redirectTo) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.updatingUser());
    let url = `${IAM_API_URL}/user/activate`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ token }),
    };

    return fetch(url, request_options)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorOnActivateAccount(error));
          dispatch(pushNotification("errors.update_user_details.error_on_activate_account", "error"));
        }
      )
      .then((response) => {
        dispatch(ActionCreators.stopLoader());
        window.location.href = "https://www.ihopa.com/welcome";
        // if ("message" in response && response.message === "Item not found") {
        //   dispatch(pushNotification("errors.update_user_details.error_on_activate_account", "error"));
        //   dispatch(ActionCreators.errorOnActivateAccount(response.message));
        //   if (redirectTo) {
        //     dispatch(navigate(redirectTo));
        //   } else {
        //     dispatch(navigate("/"));
        //   }
        // } else {
        //   dispatch(receivedAuth(response.access_token, response.refresh_token));

        //   dispatch(pushNotification("success.update_user_details.successfully_activated_account", "success"));
        //   if (redirectTo) {
        //     dispatch(navigate(redirectTo));
        //   } else {
        //     dispatch(navigate("/"));
        //   }
        // }
      });
  };
}

export function resendActivationEmail(user_guid) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.resendingActivationEmail());
    let url = `${IAM_API_URL}/user/resend-activation`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ user_guid }),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    // return fetch(url, request_options)
    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorResendingActivationEmail(error));
          dispatch(pushNotification("errors.users.resend_activation_email", "error"));
        }
      )
      .then((response) => {
        dispatch(ActionCreators.stopLoader());
        if ("message" in response || "errors" in response) {
          dispatch(pushNotification("errors.users.resend_activation_email", "error"));
          dispatch(ActionCreators.errorResendingActivationEmail(response.message));
        } else {
          if ("activation-sent" in response && response["activation-sent"]) {
            dispatch(pushNotification("success.update_user_details.resend_activation_email", "success"));
          } else {
            dispatch(pushNotification("errors.users.resend_activation_email", "error"));
          }
        }
      });
  };
}
